import { Directive, TemplateRef } from '@angular/core';

interface Context<T> {
  $implicit?: T; // current item exposed as implicit value
  index?: number;
}

@Directive({
  selector: '[appRowCells]',
  standalone: false,
})
export class RowCellsDirective {
  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public templateRef: TemplateRef<any>,
  ) {}

  static ngTemplateContextGuard<T>(
    dir: RowCellsDirective,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ctx: any,
  ): ctx is Context<T> {
    return true;
  }
}
